webpackJsonp([144482056661899],{

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(322);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var hastCssPropertyMap = {
	  align: 'text-align',
	  valign: 'vertical-align',
	  height: 'height',
	  width: 'width'
	};
	
	module.exports = function tableCellStyle(node) {
	  visit(node, 'element', visitor);
	  return node;
	};
	
	function visitor(node) {
	  if (node.tagName !== 'tr' && node.tagName !== 'td' && node.tagName !== 'th') {
	    return;
	  }
	
	  var hastName;
	  var cssName;
	  for (hastName in hastCssPropertyMap) {
	    if (
	      !hasOwnProperty.call(hastCssPropertyMap, hastName) ||
	      node.properties[hastName] === undefined
	    ) {
	      continue;
	    }
	    cssName = hastCssPropertyMap[hastName];
	    appendStyle(node, cssName, node.properties[hastName]);
	    delete node.properties[hastName];
	  }
	}
	
	function appendStyle(node, property, value) {
	  var prevStyle = (node.properties.style || '').trim();
	  if (prevStyle && !/;\s*/.test(prevStyle)) {
	    prevStyle += ';';
	  }
	  if (prevStyle) {
	    prevStyle += ' ';
	  }
	  var nextStyle = prevStyle + property + ': ' + value + ';';
	  node.properties.style = nextStyle;
	}


/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	// Parse comma-separated tokens to an array.
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = input.slice(lastIndex, index).trim()
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	// Compile an array to comma-separated tokens.
	// `options.padLeft` (default: `true`) pads a space left of each token, and
	// `options.padRight` (default: `false`) pads a space to the right of each token.
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  // Ensure the last empty entry is seen.
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return values.join(right + comma + left).trim()
	}


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(261);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(262);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	
	// declaration
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	
	// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	var TRIM_REGEX = /^\s+|\s+$/g;
	
	// strings
	var NEWLINE = '\n';
	var FORWARD_SLASH = '/';
	var ASTERISK = '*';
	var EMPTY_STRING = '';
	
	// types
	var TYPE_COMMENT = 'comment';
	var TYPE_DECLARATION = 'declaration';
	
	/**
	 * @param {String} style
	 * @param {Object} [options]
	 * @return {Object[]}
	 * @throws {TypeError}
	 * @throws {Error}
	 */
	module.exports = function(style, options) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!style) return [];
	
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   *
	   * @param {String} str
	   */
	  function updatePosition(str) {
	    var lines = str.match(NEWLINE_REGEX);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf(NEWLINE);
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   *
	   * @return {Function}
	   */
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node) {
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node.
	   *
	   * @constructor
	   * @property {Object} start
	   * @property {Object} end
	   * @property {undefined|String} source
	   */
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string.
	   */
	  Position.prototype.content = style;
	
	  var errorsList = [];
	
	  /**
	   * Error `msg`.
	   *
	   * @param {String} msg
	   * @throws {Error}
	   */
	  function error(msg) {
	    var err = new Error(
	      options.source + ':' + lineno + ':' + column + ': ' + msg
	    );
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = style;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Match `re` and return captures.
	   *
	   * @param {RegExp} re
	   * @return {undefined|Array}
	   */
	  function match(re) {
	    var m = re.exec(style);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    style = style.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	  function whitespace() {
	    match(WHITESPACE_REGEX);
	  }
	
	  /**
	   * Parse comments.
	   *
	   * @param {Object[]} [rules]
	   * @return {Object[]}
	   */
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while ((c = comment())) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function comment() {
	    var pos = position();
	    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
	
	    var i = 2;
	    while (
	      EMPTY_STRING != style.charAt(i) &&
	      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
	    ) {
	      ++i;
	    }
	    i += 2;
	
	    if (EMPTY_STRING === style.charAt(i - 1)) {
	      return error('End of comment missing');
	    }
	
	    var str = style.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    style = style.slice(i);
	    column += 2;
	
	    return pos({
	      type: TYPE_COMMENT,
	      comment: str
	    });
	  }
	
	  /**
	   * Parse declaration.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(PROPERTY_REGEX);
	    if (!prop) return;
	    comment();
	
	    // :
	    if (!match(COLON_REGEX)) return error("property missing ':'");
	
	    // val
	    var val = match(VALUE_REGEX);
	
	    var ret = pos({
	      type: TYPE_DECLARATION,
	      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
	      value: val
	        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
	        : EMPTY_STRING
	    });
	
	    // ;
	    match(SEMICOLON_REGEX);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   *
	   * @return {Object[]}
	   */
	  function declarations() {
	    var decls = [];
	
	    comments(decls);
	
	    // declarations
	    var decl;
	    while ((decl = declaration())) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    return decls;
	  }
	
	  whitespace();
	  return declarations();
	};
	
	/**
	 * Trim `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function trim(str) {
	  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var has = __webpack_require__(263);
	var toH = __webpack_require__(311);
	var tableCellStyle = __webpack_require__(180);
	
	/* Expose `rehype-react`. */
	module.exports = rehype2react;
	
	/**
	 * Attach a react compiler.
	 *
	 * @param {Unified} processor - Instance.
	 * @param {Object?} [options]
	 * @param {Object?} [options.components]
	 *   - Components.
	 * @param {string?} [options.prefix]
	 *   - Key prefix.
	 * @param {Function?} [options.createElement]
	 *   - `h()`.
	 */
	function rehype2react(options) {
	  var settings = options || {};
	  var createElement = settings.createElement;
	  var components = settings.components || {};
	
	  this.Compiler = compiler;
	
	  /* Compile HAST to React. */
	  function compiler(node) {
	    if (node.type === 'root') {
	      if (node.children.length === 1 && node.children[0].type === 'element') {
	        node = node.children[0];
	      } else {
	        node = {
	          type: 'element',
	          tagName: 'div',
	          properties: node.properties || {},
	          children: node.children
	        };
	      }
	    }
	
	    return toH(h, tableCellStyle(node), settings.prefix);
	  }
	
	  /* Wrap `createElement` to pass components in. */
	  function h(name, props, children) {
	    var component = has(components, name) ? components[name] : name;
	    return createElement(component, props, children);
	  }
	}


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var html = __webpack_require__(313)
	var svg = __webpack_require__(316)
	var find = __webpack_require__(312)
	var spaces = __webpack_require__(317)
	var commas = __webpack_require__(241)
	var style = __webpack_require__(318)
	var ns = __webpack_require__(269)
	var is = __webpack_require__(319)
	
	var dashes = /-([a-z])/g
	
	module.exports = wrapper
	
	function wrapper(h, node, options) {
	  var settings = options || {}
	  var prefix
	  var r
	  var v
	
	  if (typeof h !== 'function') {
	    throw new Error('h is not a function')
	  }
	
	  if (typeof settings === 'string' || typeof settings === 'boolean') {
	    prefix = settings
	    settings = {}
	  } else {
	    prefix = settings.prefix
	  }
	
	  r = react(h)
	  v = vdom(h)
	
	  if (prefix === null || prefix === undefined) {
	    prefix = r === true || v === true ? 'h-' : false
	  }
	
	  if (is('root', node)) {
	    if (node.children.length === 1 && is('element', node.children[0])) {
	      node = node.children[0]
	    } else {
	      node = {
	        type: 'element',
	        tagName: 'div',
	        properties: {},
	        children: node.children
	      }
	    }
	  } else if (!is('element', node)) {
	    throw new Error(
	      'Expected root or element, not `' + ((node && node.type) || node) + '`'
	    )
	  }
	
	  return toH(h, node, {
	    schema: settings.space === 'svg' ? svg : html,
	    prefix: prefix,
	    key: 0,
	    react: r,
	    vdom: v,
	    hyperscript: hyperscript(h)
	  })
	}
	
	// Transform a HAST node through a hyperscript interface
	// to *anything*!
	function toH(h, node, ctx) {
	  var parentSchema = ctx.schema
	  var schema = parentSchema
	  var name = node.tagName
	  var properties
	  var attributes
	  var children
	  var property
	  var elements
	  var length
	  var index
	  var value
	  var result
	
	  if (parentSchema.space === 'html' && name.toLowerCase() === 'svg') {
	    schema = svg
	    ctx.schema = schema
	  }
	
	  if (ctx.vdom === true && schema.space === 'html') {
	    name = name.toUpperCase()
	  }
	
	  properties = node.properties
	  attributes = {}
	
	  for (property in properties) {
	    addAttribute(attributes, property, properties[property], ctx)
	  }
	
	  if (
	    typeof attributes.style === 'string' &&
	    (ctx.vdom === true || ctx.react === true)
	  ) {
	    // VDOM and React accept `style` as object.
	    attributes.style = parseStyle(attributes.style, name)
	  }
	
	  if (ctx.prefix) {
	    ctx.key++
	    attributes.key = ctx.prefix + ctx.key
	  }
	
	  if (ctx.vdom && schema.space !== 'html') {
	    attributes.namespace = ns[schema.space]
	  }
	
	  elements = []
	  children = node.children
	  length = children ? children.length : 0
	  index = -1
	
	  while (++index < length) {
	    value = children[index]
	
	    if (is('element', value)) {
	      elements.push(toH(h, value, ctx))
	    } else if (is('text', value)) {
	      elements.push(value.value)
	    }
	  }
	
	  // Ensure no React warnings are triggered for
	  // void elements having children passed in.
	  result =
	    elements.length === 0 ? h(name, attributes) : h(name, attributes, elements)
	
	  // Restore parent schema.
	  ctx.schema = parentSchema
	
	  return result
	}
	
	function addAttribute(props, prop, value, ctx) {
	  var schema = ctx.schema
	  var info = find(schema, prop)
	  var subprop
	
	  // Ignore nully, `false`, `NaN`, and falsey known booleans.
	  if (
	    value === null ||
	    value === undefined ||
	    value === false ||
	    value !== value ||
	    (info.boolean && !value)
	  ) {
	    return
	  }
	
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    // Accept `array`.  Most props are space-separater.
	    value = (info.commaSeparated ? commas : spaces).stringify(value)
	  }
	
	  // Treat `true` and truthy known booleans.
	  if (info.boolean && ctx.hyperscript === true) {
	    value = ''
	  }
	
	  if (!info.mustUseProperty) {
	    if (ctx.vdom === true) {
	      subprop = 'attributes'
	    } else if (ctx.hyperscript === true) {
	      subprop = 'attrs'
	    }
	  }
	
	  if (subprop) {
	    if (props[subprop] === undefined) {
	      props[subprop] = {}
	    }
	
	    props[subprop][info.attribute] = value
	  } else {
	    props[ctx.react && info.space ? info.property : info.attribute] = value
	  }
	}
	
	// Check if `h` is `react.createElement`.
	function react(h) {
	  var node = h && h('div')
	  return Boolean(
	    node && ('_owner' in node || '_store' in node) && node.key === null
	  )
	}
	
	// Check if `h` is `hyperscript`.
	function hyperscript(h) {
	  return Boolean(h && h.context && h.cleanup)
	}
	
	// Check if `h` is `virtual-dom/h`.
	function vdom(h) {
	  return h && h('div').type === 'VirtualNode'
	}
	
	function parseStyle(value, tagName) {
	  var result = {}
	
	  try {
	    style(value, iterator)
	  } catch (err) {
	    err.message = tagName + '[style]' + err.message.slice('undefined'.length)
	    throw err
	  }
	
	  return result
	
	  function iterator(name, value) {
	    result[styleCase(name)] = value
	  }
	}
	
	function styleCase(val) {
	  if (val.slice(0, 4) === '-ms-') {
	    val = 'ms-' + val.slice(4)
	  }
	
	  return val.replace(dashes, styleReplacer)
	}
	
	function styleReplacer($0, $1) {
	  return $1.toUpperCase()
	}


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(112)
	var DefinedInfo = __webpack_require__(105)
	var Info = __webpack_require__(106)
	
	var data = 'data'
	
	module.exports = find
	
	var valid = /^data[-a-z0-9.:_]+$/i
	var dash = /-[a-z]/g
	var cap = /[A-Z]/g
	
	function find(schema, value) {
	  var normal = normalize(value)
	  var prop = value
	  var Type = Info
	
	  if (normal in schema.normal) {
	    return schema.property[schema.normal[normal]]
	  }
	
	  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
	    // Attribute or property.
	    if (value.charAt(4) === '-') {
	      prop = datasetToProperty(value)
	    } else {
	      value = datasetToAttribute(value)
	    }
	
	    Type = DefinedInfo
	  }
	
	  return new Type(prop, value)
	}
	
	function datasetToProperty(attribute) {
	  var value = attribute.slice(5).replace(dash, camelcase)
	  return data + value.charAt(0).toUpperCase() + value.slice(1)
	}
	
	function datasetToAttribute(property) {
	  var value = property.slice(4)
	
	  if (dash.test(value)) {
	    return property
	  }
	
	  value = value.replace(cap, kebab)
	
	  if (value.charAt(0) !== '-') {
	    value = '-' + value
	  }
	
	  return data + value
	}
	
	function kebab($0) {
	  return '-' + $0.toLowerCase()
	}
	
	function camelcase($0) {
	  return $0.charAt(1).toUpperCase()
	}


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var merge = __webpack_require__(107)
	var xlink = __webpack_require__(109)
	var xml = __webpack_require__(110)
	var xmlns = __webpack_require__(111)
	var aria = __webpack_require__(102)
	var html = __webpack_require__(314)
	
	module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(52)
	var create = __webpack_require__(34)
	
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	
	module.exports = create({
	  transform: ariaTransform,
	  properties: {
	    ariaActiveDescendant: null,
	    ariaAtomic: booleanish,
	    ariaAutoComplete: null,
	    ariaBusy: booleanish,
	    ariaChecked: booleanish,
	    ariaColCount: number,
	    ariaColIndex: number,
	    ariaColSpan: number,
	    ariaControls: spaceSeparated,
	    ariaCurrent: null,
	    ariaDescribedBy: spaceSeparated,
	    ariaDetails: null,
	    ariaDisabled: booleanish,
	    ariaDropEffect: spaceSeparated,
	    ariaErrorMessage: null,
	    ariaExpanded: booleanish,
	    ariaFlowTo: spaceSeparated,
	    ariaGrabbed: booleanish,
	    ariaHasPopup: null,
	    ariaHidden: booleanish,
	    ariaInvalid: null,
	    ariaKeyShortcuts: null,
	    ariaLabel: null,
	    ariaLabelledBy: spaceSeparated,
	    ariaLevel: number,
	    ariaLive: null,
	    ariaModal: booleanish,
	    ariaMultiLine: booleanish,
	    ariaMultiSelectable: booleanish,
	    ariaOrientation: null,
	    ariaOwns: spaceSeparated,
	    ariaPlaceholder: null,
	    ariaPosInSet: number,
	    ariaPressed: booleanish,
	    ariaReadOnly: booleanish,
	    ariaRelevant: null,
	    ariaRequired: booleanish,
	    ariaRoleDescription: spaceSeparated,
	    ariaRowCount: number,
	    ariaRowIndex: number,
	    ariaRowSpan: number,
	    ariaSelected: booleanish,
	    ariaSetSize: number,
	    ariaSort: null,
	    ariaValueMax: number,
	    ariaValueMin: number,
	    ariaValueNow: number,
	    ariaValueText: null,
	    role: null
	  }
	})
	
	function ariaTransform(_, prop) {
	  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
	}


/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(52)
	var create = __webpack_require__(34)
	var caseInsensitiveTransform = __webpack_require__(103)
	
	var boolean = types.boolean
	var overloadedBoolean = types.overloadedBoolean
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	var commaSeparated = types.commaSeparated
	
	module.exports = create({
	  space: 'html',
	  attributes: {
	    acceptcharset: 'accept-charset',
	    classname: 'class',
	    htmlfor: 'for',
	    httpequiv: 'http-equiv'
	  },
	  transform: caseInsensitiveTransform,
	  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
	  properties: {
	    // Standard Properties.
	    abbr: null,
	    accept: commaSeparated,
	    acceptCharset: spaceSeparated,
	    accessKey: spaceSeparated,
	    action: null,
	    allowFullScreen: boolean,
	    allowPaymentRequest: boolean,
	    allowUserMedia: boolean,
	    alt: null,
	    as: null,
	    async: boolean,
	    autoCapitalize: null,
	    autoComplete: spaceSeparated,
	    autoFocus: boolean,
	    autoPlay: boolean,
	    capture: boolean,
	    charSet: null,
	    checked: boolean,
	    cite: null,
	    className: spaceSeparated,
	    cols: number,
	    colSpan: null,
	    content: null,
	    contentEditable: booleanish,
	    controls: boolean,
	    controlsList: spaceSeparated,
	    coords: number | commaSeparated,
	    crossOrigin: null,
	    data: null,
	    dateTime: null,
	    decoding: null,
	    default: boolean,
	    defer: boolean,
	    dir: null,
	    dirName: null,
	    disabled: boolean,
	    download: overloadedBoolean,
	    draggable: booleanish,
	    encType: null,
	    form: null,
	    formAction: null,
	    formEncType: null,
	    formMethod: null,
	    formNoValidate: boolean,
	    formTarget: null,
	    headers: spaceSeparated,
	    height: number,
	    hidden: boolean,
	    high: number,
	    href: null,
	    hrefLang: null,
	    htmlFor: spaceSeparated,
	    httpEquiv: spaceSeparated,
	    id: null,
	    inputMode: null,
	    integrity: null,
	    is: null,
	    isMap: boolean,
	    itemId: null,
	    itemProp: spaceSeparated,
	    itemRef: spaceSeparated,
	    itemScope: boolean,
	    itemType: spaceSeparated,
	    kind: null,
	    label: null,
	    lang: null,
	    language: null,
	    list: null,
	    loop: boolean,
	    low: number,
	    manifest: null,
	    max: null,
	    maxLength: number,
	    media: null,
	    method: null,
	    min: null,
	    minLength: number,
	    multiple: boolean,
	    muted: boolean,
	    name: null,
	    nonce: null,
	    noModule: boolean,
	    noValidate: boolean,
	    open: boolean,
	    optimum: number,
	    pattern: null,
	    ping: spaceSeparated,
	    placeholder: null,
	    playsInline: boolean,
	    poster: null,
	    preload: null,
	    readOnly: boolean,
	    referrerPolicy: null,
	    rel: spaceSeparated,
	    required: boolean,
	    reversed: boolean,
	    rows: number,
	    rowSpan: number,
	    sandbox: spaceSeparated,
	    scope: null,
	    scoped: boolean,
	    seamless: boolean,
	    selected: boolean,
	    shape: null,
	    size: number,
	    sizes: spaceSeparated,
	    slot: null,
	    span: number,
	    spellCheck: booleanish,
	    src: null,
	    srcDoc: null,
	    srcLang: null,
	    srcSet: commaSeparated,
	    start: number,
	    step: null,
	    style: null,
	    tabIndex: number,
	    target: null,
	    title: null,
	    translate: null,
	    type: null,
	    typeMustMatch: boolean,
	    useMap: null,
	    value: booleanish,
	    width: number,
	    wrap: null,
	
	    // Legacy.
	    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
	    align: null, // Several. Use CSS `text-align` instead,
	    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
	    archive: spaceSeparated, // `<object>`. List of URIs to archives
	    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
	    background: null, // `<body>`. Use CSS `background-image` instead
	    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
	    border: number, // `<table>`. Use CSS `border-width` instead,
	    borderColor: null, // `<table>`. Use CSS `border-color` instead,
	    bottomMargin: number, // `<body>`
	    cellPadding: null, // `<table>`
	    cellSpacing: null, // `<table>`
	    char: null, // Several table elements. When `align=char`, sets the character to align on
	    charOff: null, // Several table elements. When `char`, offsets the alignment
	    classId: null, // `<object>`
	    clear: null, // `<br>`. Use CSS `clear` instead
	    code: null, // `<object>`
	    codeBase: null, // `<object>`
	    codeType: null, // `<object>`
	    color: null, // `<font>` and `<hr>`. Use CSS instead
	    compact: boolean, // Lists. Use CSS to reduce space between items instead
	    declare: boolean, // `<object>`
	    event: null, // `<script>`
	    face: null, // `<font>`. Use CSS instead
	    frame: null, // `<table>`
	    frameBorder: null, // `<iframe>`. Use CSS `border` instead
	    hSpace: number, // `<img>` and `<object>`
	    leftMargin: number, // `<body>`
	    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
	    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
	    lowSrc: null, // `<img>`. Use a `<picture>`
	    marginHeight: number, // `<body>`
	    marginWidth: number, // `<body>`
	    noResize: boolean, // `<frame>`
	    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
	    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
	    noWrap: boolean, // `<td>` and `<th>`
	    object: null, // `<applet>`
	    profile: null, // `<head>`
	    prompt: null, // `<isindex>`
	    rev: null, // `<link>`
	    rightMargin: number, // `<body>`
	    rules: null, // `<table>`
	    scheme: null, // `<meta>`
	    scrolling: booleanish, // `<frame>`. Use overflow in the child context
	    standby: null, // `<object>`
	    summary: null, // `<table>`
	    text: null, // `<body>`. Use CSS `color` instead
	    topMargin: number, // `<body>`
	    valueType: null, // `<param>`
	    version: null, // `<html>`. Use a doctype.
	    vAlign: null, // Several. Use CSS `vertical-align` instead
	    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
	    vSpace: number, // `<img>` and `<object>`
	
	    // Non-standard Properties.
	    allowTransparency: null,
	    autoCorrect: null,
	    autoSave: null,
	    prefix: null,
	    property: null,
	    results: number,
	    security: null,
	    unselectable: null
	  }
	})


/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(52)
	var create = __webpack_require__(34)
	var caseSensitiveTransform = __webpack_require__(104)
	
	var boolean = types.boolean
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	var commaSeparated = types.commaSeparated
	var commaOrSpaceSeparated = types.commaOrSpaceSeparated
	
	module.exports = create({
	  space: 'svg',
	  attributes: {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    className: 'class',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    crossOrigin: 'crossorigin',
	    dataType: 'datatype',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    hrefLang: 'hreflang',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    horizOriginY: 'horiz-origin-y',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    navDown: 'nav-down',
	    navDownLeft: 'nav-down-left',
	    navDownRight: 'nav-down-right',
	    navLeft: 'nav-left',
	    navNext: 'nav-next',
	    navPrev: 'nav-prev',
	    navRight: 'nav-right',
	    navUp: 'nav-up',
	    navUpLeft: 'nav-up-left',
	    navUpRight: 'nav-up-right',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDashArray: 'stroke-dasharray',
	    strokeDashOffset: 'stroke-dashoffset',
	    strokeLineCap: 'stroke-linecap',
	    strokeLineJoin: 'stroke-linejoin',
	    strokeMiterLimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    tabIndex: 'tabindex',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    typeOf: 'typeof',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	    // These were camelcased in Tiny. Now lowercased in SVG 2
	    playbackOrder: 'playbackorder',
	    timelineBegin: 'timelinebegin'
	  },
	  transform: caseSensitiveTransform,
	  properties: {
	    about: commaOrSpaceSeparated,
	    accentHeight: number,
	    accumulate: null,
	    additive: null,
	    alignmentBaseline: null,
	    alphabetic: number,
	    amplitude: number,
	    arabicForm: null,
	    ascent: number,
	    attributeName: null,
	    attributeType: null,
	    azimuth: number,
	    bandwidth: null,
	    baselineShift: null,
	    baseFrequency: null,
	    baseProfile: null,
	    bbox: null,
	    begin: null,
	    bias: number,
	    by: null,
	    calcMode: null,
	    capHeight: number,
	    className: spaceSeparated,
	    clip: null,
	    clipPath: null,
	    clipPathUnits: null,
	    clipRule: null,
	    color: null,
	    colorInterpolation: null,
	    colorInterpolationFilters: null,
	    colorProfile: null,
	    colorRendering: null,
	    content: null,
	    contentScriptType: null,
	    contentStyleType: null,
	    crossOrigin: null,
	    cursor: null,
	    cx: null,
	    cy: null,
	    d: null,
	    dataType: null,
	    defaultAction: null,
	    descent: number,
	    diffuseConstant: number,
	    direction: null,
	    display: null,
	    dur: null,
	    divisor: number,
	    dominantBaseline: null,
	    download: boolean,
	    dx: null,
	    dy: null,
	    edgeMode: null,
	    editable: null,
	    elevation: number,
	    enableBackground: null,
	    end: null,
	    event: null,
	    exponent: number,
	    externalResourcesRequired: null,
	    fill: null,
	    fillOpacity: number,
	    fillRule: null,
	    filter: null,
	    filterRes: null,
	    filterUnits: null,
	    floodColor: null,
	    floodOpacity: null,
	    focusable: null,
	    focusHighlight: null,
	    fontFamily: null,
	    fontSize: null,
	    fontSizeAdjust: null,
	    fontStretch: null,
	    fontStyle: null,
	    fontVariant: null,
	    fontWeight: null,
	    format: null,
	    fr: null,
	    from: null,
	    fx: null,
	    fy: null,
	    g1: commaSeparated,
	    g2: commaSeparated,
	    glyphName: commaSeparated,
	    glyphOrientationHorizontal: null,
	    glyphOrientationVertical: null,
	    glyphRef: null,
	    gradientTransform: null,
	    gradientUnits: null,
	    handler: null,
	    hanging: number,
	    hatchContentUnits: null,
	    hatchUnits: null,
	    height: null,
	    href: null,
	    hrefLang: null,
	    horizAdvX: number,
	    horizOriginX: number,
	    horizOriginY: number,
	    id: null,
	    ideographic: number,
	    imageRendering: null,
	    initialVisibility: null,
	    in: null,
	    in2: null,
	    intercept: number,
	    k: number,
	    k1: number,
	    k2: number,
	    k3: number,
	    k4: number,
	    kernelMatrix: commaOrSpaceSeparated,
	    kernelUnitLength: null,
	    keyPoints: null, // SEMI_COLON_SEPARATED
	    keySplines: null, // SEMI_COLON_SEPARATED
	    keyTimes: null, // SEMI_COLON_SEPARATED
	    kerning: null,
	    lang: null,
	    lengthAdjust: null,
	    letterSpacing: null,
	    lightingColor: null,
	    limitingConeAngle: number,
	    local: null,
	    markerEnd: null,
	    markerMid: null,
	    markerStart: null,
	    markerHeight: null,
	    markerUnits: null,
	    markerWidth: null,
	    mask: null,
	    maskContentUnits: null,
	    maskUnits: null,
	    mathematical: null,
	    max: null,
	    media: null,
	    mediaCharacterEncoding: null,
	    mediaContentEncodings: null,
	    mediaSize: number,
	    mediaTime: null,
	    method: null,
	    min: null,
	    mode: null,
	    name: null,
	    navDown: null,
	    navDownLeft: null,
	    navDownRight: null,
	    navLeft: null,
	    navNext: null,
	    navPrev: null,
	    navRight: null,
	    navUp: null,
	    navUpLeft: null,
	    navUpRight: null,
	    numOctaves: null,
	    observer: null,
	    offset: null,
	    opacity: null,
	    operator: null,
	    order: null,
	    orient: null,
	    orientation: null,
	    origin: null,
	    overflow: null,
	    overlay: null,
	    overlinePosition: number,
	    overlineThickness: number,
	    paintOrder: null,
	    panose1: null,
	    path: null,
	    pathLength: number,
	    patternContentUnits: null,
	    patternTransform: null,
	    patternUnits: null,
	    phase: null,
	    pitch: null,
	    playbackOrder: null,
	    pointerEvents: null,
	    points: null,
	    pointsAtX: number,
	    pointsAtY: number,
	    pointsAtZ: number,
	    preserveAlpha: null,
	    preserveAspectRatio: null,
	    primitiveUnits: null,
	    propagate: null,
	    property: commaOrSpaceSeparated,
	    r: null,
	    radius: null,
	    refX: null,
	    refY: null,
	    rel: commaOrSpaceSeparated,
	    rev: commaOrSpaceSeparated,
	    renderingIntent: null,
	    repeatCount: null,
	    repeatDur: null,
	    requiredExtensions: commaOrSpaceSeparated,
	    requiredFeatures: commaOrSpaceSeparated,
	    requiredFonts: commaOrSpaceSeparated,
	    requiredFormats: commaOrSpaceSeparated,
	    resource: null,
	    restart: null,
	    result: null,
	    rotate: null,
	    rx: null,
	    ry: null,
	    scale: null,
	    seed: null,
	    shapeRendering: null,
	    side: null,
	    slope: null,
	    snapshotTime: null,
	    specularConstant: number,
	    specularExponent: number,
	    spreadMethod: null,
	    spacing: null,
	    startOffset: null,
	    stdDeviation: null,
	    stemh: null,
	    stemv: null,
	    stitchTiles: null,
	    stopColor: null,
	    stopOpacity: null,
	    strikethroughPosition: number,
	    strikethroughThickness: number,
	    string: null,
	    stroke: null,
	    strokeDashArray: commaOrSpaceSeparated,
	    strokeDashOffset: null,
	    strokeLineCap: null,
	    strokeLineJoin: null,
	    strokeMiterLimit: number,
	    strokeOpacity: number,
	    strokeWidth: null,
	    style: null,
	    surfaceScale: number,
	    syncBehavior: null,
	    syncBehaviorDefault: null,
	    syncMaster: null,
	    syncTolerance: null,
	    syncToleranceDefault: null,
	    systemLanguage: commaOrSpaceSeparated,
	    tabIndex: number,
	    tableValues: null,
	    target: null,
	    targetX: number,
	    targetY: number,
	    textAnchor: null,
	    textDecoration: null,
	    textRendering: null,
	    textLength: null,
	    timelineBegin: null,
	    title: null,
	    transformBehavior: null,
	    type: null,
	    typeOf: commaOrSpaceSeparated,
	    to: null,
	    transform: null,
	    u1: null,
	    u2: null,
	    underlinePosition: number,
	    underlineThickness: number,
	    unicode: null,
	    unicodeBidi: null,
	    unicodeRange: null,
	    unitsPerEm: number,
	    values: null,
	    vAlphabetic: number,
	    vMathematical: number,
	    vectorEffect: null,
	    vHanging: number,
	    vIdeographic: number,
	    version: null,
	    vertAdvY: number,
	    vertOriginX: number,
	    vertOriginY: number,
	    viewBox: null,
	    viewTarget: null,
	    visibility: null,
	    width: null,
	    widths: null,
	    wordSpacing: null,
	    writingMode: null,
	    x: null,
	    x1: null,
	    x2: null,
	    xChannelSelector: null,
	    xHeight: number,
	    y: null,
	    y1: null,
	    y2: null,
	    yChannelSelector: null,
	    z: null,
	    zoomAndPan: null
	  }
	})


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var caseSensitiveTransform = __webpack_require__(104)
	
	module.exports = caseInsensitiveTransform
	
	function caseInsensitiveTransform(attributes, property) {
	  return caseSensitiveTransform(attributes, property.toLowerCase())
	}


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = caseSensitiveTransform
	
	function caseSensitiveTransform(attributes, attribute) {
	  return attribute in attributes ? attributes[attribute] : attribute
	}


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(112)
	var Schema = __webpack_require__(108)
	var DefinedInfo = __webpack_require__(105)
	
	module.exports = create
	
	function create(definition) {
	  var space = definition.space
	  var mustUseProperty = definition.mustUseProperty || []
	  var attributes = definition.attributes || {}
	  var props = definition.properties
	  var transform = definition.transform
	  var property = {}
	  var normal = {}
	  var prop
	  var info
	
	  for (prop in props) {
	    info = new DefinedInfo(
	      prop,
	      transform(attributes, prop),
	      props[prop],
	      space
	    )
	
	    if (mustUseProperty.indexOf(prop) !== -1) {
	      info.mustUseProperty = true
	    }
	
	    property[prop] = info
	
	    normal[normalize(prop)] = prop
	    normal[normalize(info.attribute)] = prop
	  }
	
	  return new Schema(property, normal, space)
	}


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var Info = __webpack_require__(106)
	var types = __webpack_require__(52)
	
	module.exports = DefinedInfo
	
	DefinedInfo.prototype = new Info()
	DefinedInfo.prototype.defined = true
	
	function DefinedInfo(property, attribute, mask, space) {
	  mark(this, 'space', space)
	  Info.call(this, property, attribute)
	  mark(this, 'boolean', check(mask, types.boolean))
	  mark(this, 'booleanish', check(mask, types.booleanish))
	  mark(this, 'overloadedBoolean', check(mask, types.overloadedBoolean))
	  mark(this, 'number', check(mask, types.number))
	  mark(this, 'commaSeparated', check(mask, types.commaSeparated))
	  mark(this, 'spaceSeparated', check(mask, types.spaceSeparated))
	  mark(this, 'commaOrSpaceSeparated', check(mask, types.commaOrSpaceSeparated))
	}
	
	function mark(values, key, value) {
	  if (value) {
	    values[key] = value
	  }
	}
	
	function check(value, mask) {
	  return (value & mask) === mask
	}


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Info
	
	var proto = Info.prototype
	
	proto.space = null
	proto.attribute = null
	proto.property = null
	proto.boolean = false
	proto.booleanish = false
	proto.overloadedBoolean = false
	proto.number = false
	proto.commaSeparated = false
	proto.spaceSeparated = false
	proto.commaOrSpaceSeparated = false
	proto.mustUseProperty = false
	proto.defined = false
	
	function Info(property, attribute) {
	  this.property = property
	  this.attribute = attribute
	}


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(455)
	var Schema = __webpack_require__(108)
	
	module.exports = merge
	
	function merge(definitions) {
	  var length = definitions.length
	  var property = []
	  var normal = []
	  var index = -1
	  var info
	  var space
	
	  while (++index < length) {
	    info = definitions[index]
	    property.push(info.property)
	    normal.push(info.normal)
	    space = info.space
	  }
	
	  return new Schema(
	    xtend.apply(null, property),
	    xtend.apply(null, normal),
	    space
	  )
	}


/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Schema
	
	var proto = Schema.prototype
	
	proto.space = null
	proto.normal = {}
	proto.property = {}
	
	function Schema(property, normal, space) {
	  this.property = property
	  this.normal = normal
	
	  if (space) {
	    this.space = space
	  }
	}


/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	'use strict'
	
	var powers = 0
	
	exports.boolean = increment()
	exports.booleanish = increment()
	exports.overloadedBoolean = increment()
	exports.number = increment()
	exports.spaceSeparated = increment()
	exports.commaSeparated = increment()
	exports.commaOrSpaceSeparated = increment()
	
	function increment() {
	  return Math.pow(2, ++powers)
	}


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(34)
	
	module.exports = create({
	  space: 'xlink',
	  transform: xlinkTransform,
	  properties: {
	    xLinkActuate: null,
	    xLinkArcRole: null,
	    xLinkHref: null,
	    xLinkRole: null,
	    xLinkShow: null,
	    xLinkTitle: null,
	    xLinkType: null
	  }
	})
	
	function xlinkTransform(_, prop) {
	  return 'xlink:' + prop.slice(5).toLowerCase()
	}


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(34)
	
	module.exports = create({
	  space: 'xml',
	  transform: xmlTransform,
	  properties: {
	    xmlLang: null,
	    xmlBase: null,
	    xmlSpace: null
	  }
	})
	
	function xmlTransform(_, prop) {
	  return 'xml:' + prop.slice(3).toLowerCase()
	}


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(34)
	var caseInsensitiveTransform = __webpack_require__(103)
	
	module.exports = create({
	  space: 'xmlns',
	  attributes: {
	    xmlnsxlink: 'xmlns:xlink'
	  },
	  transform: caseInsensitiveTransform,
	  properties: {
	    xmlns: null,
	    xmlnsXLink: null
	  }
	})


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = normalize
	
	function normalize(value) {
	  return value.toLowerCase().replace(/\b[:-]\b/g, '')
	}


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var merge = __webpack_require__(107)
	var xlink = __webpack_require__(109)
	var xml = __webpack_require__(110)
	var xmlns = __webpack_require__(111)
	var aria = __webpack_require__(102)
	var svg = __webpack_require__(315)
	
	module.exports = merge([xml, xlink, xmlns, aria, svg])


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = String(value || empty).trim()
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return values.join(space).trim()
	}


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(268);
	
	/**
	 * Parses inline style to object.
	 *
	 * @example
	 * // returns { 'line-height': '42' }
	 * StyleToObject('line-height: 42;');
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	function StyleToObject(style, iterator) {
	  var output = null;
	  if (!style || typeof style !== 'string') {
	    return output;
	  }
	
	  var declaration;
	  var declarations = parse(style);
	  var hasIterator = typeof iterator === 'function';
	  var property;
	  var value;
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	}
	
	module.exports = StyleToObject;


/***/ }),

/***/ 319:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = is
	
	// Assert if `test` passes for `node`.   When a `parent` node is known the
	// `index` of node.
	// eslint-disable-next-line max-params
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined
	  var hasIndex = index !== null && index !== undefined
	  var check = convert(test)
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node')
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node')
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index')
	  }
	
	  return Boolean(check.call(context, node, index, parent))
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var convert = __webpack_require__(321)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  var is
	
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  is = convert(test)
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result = []
	    var subresult
	
	    if (!test || is(node, index, parents[parents.length - 1] || null)) {
	      result = toResult(visitor(node, parents))
	
	      if (result[0] === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result[0] !== SKIP) {
	      subresult = toResult(all(node.children, parents.concat(node)))
	      return subresult[0] === EXIT ? subresult : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var result
	
	    while (index > min && index < children.length) {
	      result = one(children[index], index, parents)
	
	      if (result[0] === EXIT) {
	        return result
	      }
	
	      index = typeof result[1] === 'number' ? result[1] : index + step
	    }
	  }
	}
	
	function toResult(value) {
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    return value
	  }
	
	  if (typeof value === 'number') {
	    return [CONTINUE, value]
	  }
	
	  return [value]
	}


/***/ }),

/***/ 321:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = convert
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(320)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	module.exports = {"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = a;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function a(_ref) {
	  var children = _ref.children,
	      href = _ref.href;
	
	  return _react2.default.createElement(
	    _link2.default,
	    { type: 'blue', url: href },
	    children
	  );
	}
	
	a.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  href: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = c;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function c(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    children
	  );
	}
	
	c.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _hModule = __webpack_require__(726);
	
	var _hModule2 = _interopRequireDefault(_hModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var h = function h(_ref) {
	  var tag = _ref.tag,
	      size = _ref.size,
	      position = _ref.position,
	      spacing = _ref.spacing;
	  return function (props) {
	    return _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', position: position, size: spacing },
	      _react2.default.createElement(
	        'div',
	        {
	          className: _hModule2.default.anchorOffsetForFixedHeader,
	          id: convertToIdName(props.children[0])
	        },
	        _react2.default.createElement(
	          _heading2.default,
	          { tag: tag, size: size, weight: 'semibold' },
	          props.children
	        )
	      )
	    );
	  };
	};
	
	function convertToIdName(string) {
	  var alphanumberic = string.replace(/[^\w\s]/gi, '');
	  return alphanumberic.replace(/ /g, '-').toLowerCase();
	}
	
	exports.default = h;
	module.exports = exports['default'];

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"anchorOffsetForFixedHeader":"src-components-markdown----h-module---anchorOffsetForFixedHeader---2LRAq"};

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _a = __webpack_require__(551);
	
	var _a2 = _interopRequireDefault(_a);
	
	var _li = __webpack_require__(556);
	
	var _li2 = _interopRequireDefault(_li);
	
	var _l = __webpack_require__(555);
	
	var _l2 = _interopRequireDefault(_l);
	
	var _h = __webpack_require__(553);
	
	var _h2 = _interopRequireDefault(_h);
	
	var _p = __webpack_require__(557);
	
	var _p2 = _interopRequireDefault(_p);
	
	var _pre = __webpack_require__(558);
	
	var _pre2 = _interopRequireDefault(_pre);
	
	var _c = __webpack_require__(552);
	
	var _c2 = _interopRequireDefault(_c);
	
	var _table = __webpack_require__(559);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _td = __webpack_require__(560);
	
	var _td2 = _interopRequireDefault(_td);
	
	var _th = __webpack_require__(561);
	
	var _th2 = _interopRequireDefault(_th);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  a: _a2.default,
	  li: _li2.default,
	  ul: (0, _l2.default)({ type: 'unordered' }),
	  ol: (0, _l2.default)({ type: 'ordered' }),
	  h1: (0, _h2.default)({ tag: 'h1', size: 'xxxl', position: 'bottom', spacing: 'm' }),
	  h2: (0, _h2.default)({ tag: 'h2', size: 'xxl', position: 'topBottom', spacing: 'm' }),
	  h3: (0, _h2.default)({ tag: 'h3', size: 'xl', position: 'topBottom', spacing: 'm' }),
	  h4: (0, _h2.default)({ tag: 'h4', size: 'l', position: 'topBottom', spacing: 's' }),
	  h5: (0, _h2.default)({ tag: 'h5', size: 'm', position: 'topBottom', spacing: 's' }),
	  pre: _pre2.default,
	  p: _p2.default,
	  c: _c2.default,
	  table: _table2.default,
	  td: _td2.default,
	  th: _th2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _list = __webpack_require__(116);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var l = function l(_ref) {
	  var type = _ref.type;
	
	  return function (props) {
	    var elements = filterChildren(props.children, function (child) {
	      return child !== '\n';
	    });
	    return _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', position: 'topBottom', size: 'm' },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { tag: 'div', size: 'l' },
	        _react2.default.createElement(
	          _list2.default,
	          { type: type },
	          elements
	        )
	      )
	    );
	  };
	};
	
	exports.default = l;
	
	
	function filterChildren(children, predicate) {
	  return _react.Children.toArray(children).filter(predicate);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = li;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function li(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    children
	  );
	}
	
	li.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = p;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function p(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', position: 'bottom', size: 'm' },
	    _react2.default.createElement(
	      _paragraph2.default,
	      { size: 'l' },
	      children
	    )
	  );
	}
	
	p.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = pre;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pre(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', position: 'bottom', size: 'm' },
	    _react2.default.createElement(
	      'pre',
	      { className: 'bg-snow padding-m borderRadius-m borderWidth-1 borderStyle-solid borderColor-smoke overflow-auto' },
	      children
	    )
	  );
	}
	
	pre.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = table;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tableModule = __webpack_require__(727);
	
	var _tableModule2 = _interopRequireDefault(_tableModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function table(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'table',
	    { className: _tableModule2.default.table },
	    children
	  );
	}
	
	table.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"table":"src-components-markdown----table-module---table---ql7wY borderWidth-1 borderStyle-solid borderColor-smoke marginTop-m marginBottom-m overflow-hidden borderRadius-m"};

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = td;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _tdModule = __webpack_require__(728);
	
	var _tdModule2 = _interopRequireDefault(_tdModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function td(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'td',
	    { className: _tdModule2.default.td },
	    _react2.default.createElement(
	      _paragraph2.default,
	      null,
	      children
	    )
	  );
	}
	
	td.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"td":"src-components-markdown----td-module---td---nOVza padding-s borderWidth-0 borderBottomWidth-1 borderRightWidth-1 borderStyle-solid borderColor-smoke--d"};

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = th;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _thModule = __webpack_require__(729);
	
	var _thModule2 = _interopRequireDefault(_thModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function th(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'th',
	    { className: _thModule2.default.th },
	    _react2.default.createElement(
	      _heading2.default,
	      { tag: 'div', size: 'm', color: 'black', weight: 'semibold' },
	      children
	    )
	  );
	}
	
	th.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"th":"src-components-markdown----th-module---th---2m2D1 padding-s bg-snow borderWidth-0 borderBottomWidth-1 borderRightWidth-1 borderStyle-solid textAlign-center borderColor-smoke--d"};

/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = NavDropdown;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NavDropdown(_ref) {
	  var url = _ref.url,
	      items = _ref.items,
	      title = _ref.title,
	      active = _ref.active;
	
	  var type = active ? 'blue' : 'dark';
	  var paddingBottom = active && items ? 'xxs' : 'xxxs';
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'paddingTop', size: 'xxxs' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'paddingBottom', size: paddingBottom },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'fontSize-l fontWeight-5', to: url },
	        _react2.default.createElement(
	          _link2.default,
	          { type: type },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', position: 'topBottom', size: 's' },
	        items && active && items.map(function (dropdownItem) {
	          return _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', position: 'left', size: 'm' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', position: 'topBottom', size: 'xxs' },
	              _react2.default.createElement(
	                _paragraph2.default,
	                { tag: 'div', size: 'm', color: 'silver' },
	                _react2.default.createElement(
	                  _link2.default,
	                  { onClick: function onClick(e) {
	                      return scrollTo(e, dropdownItem.url);
	                    } },
	                  dropdownItem.title
	                )
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	function scrollTo(e, targetUrl) {
	  var idx = targetUrl.indexOf('#');
	  var hashString = idx !== -1 ? targetUrl.substring(idx + 1) : '';
	  var targetElement = document.getElementById(hashString);
	
	  if (targetElement) {
	    e.preventDefault();
	    history.pushState({}, '', targetUrl);
	    setTimeout(function () {
	      targetElement.scrollIntoView({
	        behavior: 'smooth',
	        block: 'start',
	        inline: 'start'
	      });
	    }, 50);
	  } else {
	    (0, _gatsbyLink.navigateTo)(targetUrl);
	  }
	}
	
	NavDropdown.propTypes = {
	  url: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  items: _propTypes2.default.array.isRequired,
	  active: _propTypes2.default.bool.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(51);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _devSidebarLinks = __webpack_require__(950);
	
	var _devSidebarLinks2 = _interopRequireDefault(_devSidebarLinks);
	
	var _NavDropdown = __webpack_require__(1210);
	
	var _NavDropdown2 = _interopRequireDefault(_NavDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sidebar(_ref) {
	  var location = _ref.location;
	
	  function itemIsActive(item) {
	    var itemPaths = urlPaths(item.url);
	    var currentPaths = urlPaths(location.pathname);
	
	    // Example: developers/documentation/[current path]
	    if (itemPaths[2] === currentPaths[2]) {
	      return true;
	    }
	
	    return false;
	  }
	
	  function urlPaths(url) {
	    var noHashUrl = url.replace(/(#.+?)$/, '?var=1$1');
	    var slitUrl = noHashUrl.split('/');
	    var removeEmptyValues = slitUrl.filter(function (e) {
	      return e;
	    });
	    return removeEmptyValues;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _heading2.default,
	      { tag: 'h5', weight: 'normal', size: 's', color: 'silver' },
	      'Contents'
	    ),
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', position: 'top', size: 'm' },
	      _devSidebarLinks2.default.map(function (item) {
	        return _react2.default.createElement(_NavDropdown2.default, {
	          key: item.id,
	          items: item.items,
	          title: item.title,
	          url: item.url,
	          type: item.type,
	          active: itemIsActive(item)
	        });
	      })
	    )
	  );
	}
	
	exports.default = (0, _reactRouterDom.withRouter)(Sidebar);
	
	
	Sidebar.propTypes = {
	  location: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.apiDocQuery = undefined;
	exports.default = ApiDocDetailTemplate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rehypeReact = __webpack_require__(310);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _markdown = __webpack_require__(554);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Sidebar = __webpack_require__(1211);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _docs = __webpack_require__(1516);
	
	var _docs2 = _interopRequireDefault(_docs);
	
	__webpack_require__(1515);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ApiDocDetailTemplate(_ref) {
	  var data = _ref.data;
	
	  if (!data || !data.markdownRemark) return null;
	
	  var markdownRemark = data.markdownRemark;
	  var frontmatter = markdownRemark.frontmatter,
	      htmlAst = markdownRemark.htmlAst;
	  var page = frontmatter.page;
	
	
	  var renderAst = new _rehypeReact2.default({
	    createElement: _react2.default.createElement,
	    components: _markdown2.default
	  }).Compiler;
	
	  var developers = _metadata2.default.developers;
	
	  var pageProps = {
	    title: '' + developers[page].title,
	    meta: getMetaTags(developers[page].description, developers[page].keywords),
	    header: {
	      type: 'developer'
	    },
	    footer: false
	  };
	
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { maxWidth: 1016 },
	      _react2.default.createElement(
	        'div',
	        { className: _docs2.default.page },
	        _react2.default.createElement(
	          'div',
	          { className: _docs2.default.leftColumn },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: 770 },
	            _react2.default.createElement(_Sidebar2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: 770 },
	          _react2.default.createElement(
	            'div',
	            { className: _docs2.default.rightColumn },
	            renderAst(htmlAst)
	          )
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { maxWidth: 770 },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', position: 'top', size: 'm' },
	            renderAst(htmlAst)
	          )
	        )
	      )
	    )
	  );
	}
	
	ApiDocDetailTemplate.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      htmlAst: _propTypes2.default.object,
	      frontmatter: _propTypes2.default.shape({
	        page: _customPropTypesCheck2.default,
	        summary: _customPropTypesCheck2.default
	      })
	    })
	  })
	};
	
	var apiDocQuery = exports.apiDocQuery = '** extracted graphql fragment **';
	
	function getMetaTags(description, keywords) {
	  var meta = [];
	  if (description) {
	    meta.push({ name: 'description', content: description });
	  }
	  if (keywords) {
	    meta.push({ name: 'keywords', content: keywords });
	  }
	  return meta;
	}

/***/ }),

/***/ 1515:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1516:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"_1l3t6SIuxIsAmX-bnipD9B pageWrap-l paddingBottom-xl centered","leftColumn":"Ju-mpIxoeoX_zacHKWdeu position-fixed paddingTopBottom-xl overflow-scroll","rightColumn":"fsTRvLNOFqxiy51PF_7U0"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-api-docs-js-d4e8b15438bc76995748.js